export default {
      id: "access-right-usage",
      viewBox: "0 0 21 25",
      url: __webpack_public_path__ + "img/icons.svg#access-right",
      toString: function () {
        return this.url;
      }
    }